<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import { getDepotList, getIndexData, FileUrl } from "@/api/depotApi";
import { getInfo } from "@/api/systemApi.js";
export default {
  name: "App",
  provide (){
    return {
      reload:this.reload
    }
  },
  data() { 
    return{
      isRouterAlive:true
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  
  },
  created() {
   

    if (sessionStorage.getItem("store")) {
      // replaceState 替换state根状态（参数为 对象）
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    this.depostInfo()
    this.deptApproveConfig()
  },
  methods: {
    //获取公司配置-仪器审批开关（页面刷新时若store中已有则跳过）
    deptApproveConfig() {
      if (!this.userInfo || !this.userInfo.deptId) {
        return
      }
      const needApprove = this.$store.state.user.needApprove;
      if (needApprove !== null && needApprove !== undefined) {
        return
      }
      getInfo(this.userInfo.deptId).then((res) => {
        if (res.code == "200" && res.data) {
          this.$store.dispatch("setNeedApprove", res.data.needApprove);
        }
      });
    },
        //获取仓库数据
        depostInfo() {
          // 只在用户信息完整且不是登录页面时调用接口
          // 优先使用userInfo判断，避免路径判断的问题
          if(!this.userInfo||!this.userInfo.deptId) {
    return
          }
          // 登录页面在login组件中已经单独调用了depostInfo方法，这里不需要再调用
      getDepotList({ deptId:this.userInfo.roleId==1?'': this.userInfo.deptId }).then((res) => {
        if (res.code == "200") {
          this.$store.dispatch("setDepotList", res.data);
        }
      });
    },
    reload(){
      this.isRouterAlive =false;
      this.$nextTick(()=>{
        this.isRouterAlive =true;
      });
    },
  }
};
</script>

<style lang="less">
// @import "./assets/iconfont/iconfont.css";
// @import "./assets/css/commonStyle.less";
// @import "./assets/css/style.less"; //自定义组件样式
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.bar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.bar::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #86cbfd;
}
.bar::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #1f94f1;
}


</style>



// WEBPACK FOOTER //
// src/App.vue